import { StandardDialog } from '@roc/ui';
import { FundingTemplate } from './fundingTemplate';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type EstimateFundingTemplateDialogProps = {
  open?: boolean;
  onClose?: () => void;
  document: Document;
};

export const EstimateFundingTemplateDialog = (props: EstimateFundingTemplateDialogProps) => {
  const { open, onClose, document } = props;
  const taskId = document?.taskId;

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title=""
          maxWidth="xl" // TODO: should I change this??
          handleClose={onClose}
          dialogContent={<FundingTemplate />}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title=""
          maxWidth="xl"
          handleClose={onClose}
          dialogContent={<FundingTemplate />}
        />
      )}
    </>
  );
};

export default EstimateFundingTemplateDialog;
